import { GET_PARKING_TYPES, VEHICLE_TYPE } from "../services/apiUrls";
import { get } from "../services/service";

export const fetchAllParkingTypes = async (locationId, tenantId) => {
  let response = await get(
    GET_PARKING_TYPES.replace("{tenantId}", tenantId).replace(
      "{locationId}",
      locationId
    )
  );
  return response;
};

export const getVehicleType = async (locationId, tenantId) => {
  let response = await get(
    VEHICLE_TYPE.replace("{tenantId}", tenantId).replace(
      "{locationId}",
      locationId
    )
  );
  return response;
};
